import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  buildCanonicalUrl,
  buildHomepageSoftwareApplicationJsonLd,
  getSeoForPath,
} from "./seoConfig";

const SEO_OWNER_ATTRIBUTE = "data-reelitpro-seo";
const JSON_LD_ID = "reelitpro-software-application-jsonld";

function upsertMeta(attributeName, attributeValue, content) {
  let element = document.head.querySelector(
    `meta[${attributeName}="${attributeValue}"]`
  );

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attributeName, attributeValue);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
  element.setAttribute(SEO_OWNER_ATTRIBUTE, "true");
}

function upsertCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
  element.setAttribute(SEO_OWNER_ATTRIBUTE, "true");
}

function upsertHomepageJsonLd(pathname) {
  const existingElement = document.getElementById(JSON_LD_ID);

  if (pathname !== "/") {
    existingElement?.remove();
    return;
  }

  const element = existingElement || document.createElement("script");
  element.id = JSON_LD_ID;
  element.type = "application/ld+json";
  element.setAttribute(SEO_OWNER_ATTRIBUTE, "true");
  element.textContent = JSON.stringify(buildHomepageSoftwareApplicationJsonLd());

  if (!existingElement) {
    document.head.appendChild(element);
  }
}

export default function RouteSeo() {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(location.pathname);
    const canonicalUrl = buildCanonicalUrl(seo.path);

    document.title = seo.title;
    upsertMeta("name", "description", seo.description);
    upsertCanonical(canonicalUrl);
    upsertMeta("property", "og:title", seo.title);
    upsertMeta("property", "og:description", seo.description);
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary");
    upsertMeta("name", "twitter:title", seo.title);
    upsertMeta("name", "twitter:description", seo.description);
    upsertMeta("name", "twitter:url", canonicalUrl);
    upsertHomepageJsonLd(seo.path);
  }, [location.pathname]);

  return null;
}
